import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function Label(props) {
    const { title, className = '', children, style, ...otherProps } = props;
    return (_jsxs("div", { style: { display: 'flex', alignItems: 'center', ...style?.container }, children: [_jsx("label", { className: className, style: {
                    fontSize: '12px',
                    color: '#232323',
                    paddingRight: '10px',
                    width: 'max-content',
                    ...style?.label,
                }, ...otherProps, children: title }), _jsx("div", { style: style?.wrapper, children: children })] }));
}
